<template>
  <div id="main" class="white">
    <mescroll-vue class="mescroll" ref="mescroll" :class="{'mescroll1':isIos}" :down="mescrollDown" :up="mescrollUp"
                  @init="mescrollInit" id="listId">
      <!--内容...-->
      <div class="top">
        <!--      轮播-->
        <swiper-box :images="info.bannerList" :valueKey="'image'"></swiper-box>
        <!-- 15个按钮导航-->
        <div class="goItem white">
          <van-grid :column-num="5" :border="false">
            <van-grid-item
              v-for="(item,i) in info.categoryList"
              :key="i"
              :text="item.name"
              @click="menuTo(item)"
            >
              <!--@click="pushTo(secondList[i],item.name)"-->
              <img slot="icon" :src="item.icon" alt="" style="width: 80%">
              <div slot="text" class="f14">{{ item.name }}</div>
            </van-grid-item>
          </van-grid>
        </div>
        <!-- 公告-->
        <div class="tips white">
          <van-row class="flex content">
            <van-col span="6" class="notice_t"><img src="../../assets/image/common/wohuitoutiao.png" alt=""
                                                    style="width: 70%"></van-col>
            <span style="display: inline-block;width: 1px;height: .4rem; background: #c0c0c0"></span>
            <van-col span="18" class="notice" @click="pushTo('/announcementList')">
              <van-swipe vertical style="height: .8rem" :autoplay="4000" loop :show-indicators="false">
                <van-swipe-item v-for="(item, i) in info.announcementList" :key="i">
                  <div class="pub_left overell">{{ item.title }}</div>
                </van-swipe-item>
              </van-swipe>
            </van-col>
          </van-row>
        </div>
      </div>
      <!--1111、618活动-->
      <div class="white" style="padding-top: 1.5%;">
        <div class="fine flex flex_start">
          <div class="fine_item white" style="margin: 0;" v-for="(item,i) in info.activityList" :key="i"
               @click="active(item)">
            <div style="margin: 0 .05rem;"><img :src="item.image" width="100%"></div>
          </div>
        </div>
      </div>

      <!--热销商品-->
      <div class="recommen white">
        <div class="tit f16 flex ">
          <img src="../../assets/image/common/rexiaochanpin.png" alt="" style="width: .5rem;margin-right: .2rem">
          <b>热销商品</b>
        </div>
        <div class="good_box white">
          <div class="flex scroll white">
            <div class="white good_item" v-for="(item,i) in info.recommendList">
              <good-card :scale="0.9" :item="item" :showType="'ztk'"></good-card>
            </div>
          </div>
        </div>
      </div>
      <!--6个模块-->
      <div class="second_box">
        <div class="activity_2 flex space_between">
          <div class="white col-1-3" @click="pushTo('/kill')">
            <p class="f16"><b>限时秒杀</b></p>
            <p class="orange f14">限时秒杀</p>
            <div class="imgbox">
              <img :src="info.msIcon" alt="">
            </div>
          </div>
          <div class="white col-1-3" @click="pushTo('/baoyou')">
            <p class="f16"><b>9.9包邮</b></p>
            <p class="orange f14">9.9限量抢</p>
            <div class="imgbox">
              <img :src="info.byIcon" alt="">
            </div>
          </div>
          <div class="white col-1-3" @click="pushTo('/fupin')">
            <p class="f16"><b>扶贫</b></p>
            <p class="orange f14">扶贫专区</p>
            <div class="imgbox">
              <img :src="info.fpIcon" alt="">
            </div>
          </div>
        </div>
        <div class="activity_2 flex space_between">
          <div class="white col-1-3" @click="pushTo('/brands')">
            <p class="f16"><b>品牌闪购</b></p>
            <p class="orange f14">品牌精选</p>
            <div class="imgbox">
              <img :src="info.sgIcon" alt="">
            </div>
          </div>
          <div class="white col-1-3" @click="pushTo('/dou')">
            <p class="f16"><b>抖券</b></p>
            <p class="orange f14">刷抖券</p>
            <div class="imgbox">
              <img :src="info.dqIcon" alt="">
            </div>
          </div>
          <!--<div class="white col-1-3" @click="enterEleme">-->
          <!--<p class="f16"><b>饿了么</b></p>-->
          <!--<p class="orange f14">饿了么</p>-->
          <!--<div class="imgbox">-->
          <!--<img :src="info.dqIcon" alt="">-->
          <!--</div>-->
          <!--</div>-->
          <div class="white col-1-3" @click="pushTo('/goOut?type=101','跨境优选')">
            <p class="f16"><b>跨境优选</b></p>
            <p class="orange f14">优选全球好货</p>
            <div class="imgbox">
              <img :src="info.yxIcon" alt="">
            </div>
          </div>
        </div>
      </div>
      <!--商品列表-->
      <div class="finegood white">
        <div>
          <img src="../../assets/image/common/jingxuanzhuanqu.png" alt="" style="width: 70%">
          <!--        <van-divider :style="{ color: '#fa3a25', borderColor: '#fa3a25', padding: '0 20%' }">-->
          <!--&lt;!&ndash;          <b class="f16" style="padding: 0 10%">精选专区</b>&ndash;&gt;-->
          <!--        </van-divider>-->
        </div>
        <div class="fine flex flex_start">
          <div class="fine_item white" v-for="(item,i) in dataList" :key="i">
            <good-card :scale="0.9" :item="item" :showType="'pdd'"></good-card>
            <!--<good-card :scale="0.9" :item="item" :showType="'ztk'"></good-card>-->

          </div>
        </div>
      </div>
    </mescroll-vue>
    <van-popup
      v-model="showtkl"
      style="border-radius: 10px"
      :style="{ width: '80%'}"
    >
      <div class="f14 main_co" style="line-height: 2.5;margin-top: .2rem"><b>复制淘口令后，打开淘宝APP</b></div>
      <div class="text pub_left f14"
           style="background: #f5f5f5;padding: 6px;margin:4px 16px 16px;color:#666666;min-height: 2rem">
        {{ tkl }}
      </div>
      <div class="label_hr"></div>
      <div>
        <p class="main_co f14 copy" style="line-height: 2.5" @click="onCopy(tkl)">复制淘口令</p>
      </div>
    </van-popup>
  </div>

</template>

<script>
import {boutiqueList, boutiquePddList, doItemCpsUrl, DuoduoRouter} from '../../api/home'
import {getAuthInfo, getHdongUrl} from '../../api/third'
import {getRelationId, openTklCreate} from '../../api/my'

export default {
  name: 'fine',
  props: {
    id: String,
    info: Object
  },
  data() {
    return {
      imageList: [],
      secondList: [
        {title: '我惠云店', route: '/benefit', img: require('../../assets/logo.png'), nav: 1},
        // {title: 'C2F优选', route: '/cflist', img: require('../../assets/logo.png')},
        {
          title: '爆品优选',
          route: '/List?type=bpyx&temp=baopinyouxuan&title=爆品优选',
          img: require('../../assets/logo.png')
        },
        {
          title: '惠康优品',
          route: '/List?type=hkyp&temp=hkyoupin&title=惠康优品',
          img: require('../../assets/logo.png')
        },
        {title: '惠拼优选', route: '/huipinSearch', img: require('../../assets/logo.png')},
        {title: 'C2F留言', route: '/advance', img: require('../../assets/logo.png')},
        {title: '天猫', route: '/goOut?type=6', img: require('../../assets/logo.png')},
        {title: '淘宝', route: '/goOut?type=7', img: require('../../assets/logo.png')},
        {title: '京东', route: '/goOut?type=8', img: require('../../assets/logo.png')},
        {title: '聚划算', route: '/goOut?type=9', img: require('../../assets/logo.png')},
        {title: '拼多多', route: '/goOut?type=10', img: require('../../assets/logo.png')},
        {title: '饿了么', elmeurl: '10', img: require('../../assets/logo.png')},
        {title: '刷抖券', route: '/dou', img: require('../../assets/logo.png')},
        {title: '订酒店', meituan: '10', img: require('../../assets/logo.png')},
        {
          title: '充话费',
          route: '/dou',
          url: 'https://mobile.yangkeduo.com/duo_transfer_channel.html?resourceType=39997&pid=9191823_124849939&cpsSign=CE_191224_9191823_124849939_5bffabd6ed508902844293bb22b9a31d&duoduo_type=2',
          img: require('../../assets/logo.png')
        },
        {title: '跨境购', route: '/goOut?type=101', img: require('../../assets/logo.png')},
      ],
      mescrollDown: {
        // callback: this.downCallback,
        // htmlContent: '<p class="downwarp-progress"></p><p class="downwarp-tip"></p>'
      }, // 下拉刷新的配置. (如果下拉刷新和上拉加载处理的逻辑是一样的,则mescrollDown可不用写了)
      mescrollUp: { // 上拉加载的配置.
        auto: true,
        callback: this.upCallback, // 上拉回调,此处简写; 相当于 callback: function(page, mescroll) { }
        // 以下是一些常用的配置,当然不写也可以的.
        page: {
          num: 1, // 当前页 默认0,回调之前会加1; 即callback(page)会从1开始
          size: 10 // 每页数据条数,默认10
        },
        // htmlNodata: '<p class="upwarp-nodata">-- END --</p>',
        noMoreSize: 5, // 如果列表已无数据,可设置列表的总数量要大于5才显示无更多数据;
        // 避免列表数据过少(比如只有一条数据),显示无更多数据会不好看
        // 这就是为什么无更多数据有时候不显示的原因
        toTop: {
          // 回到顶部按钮
          // warpId: 'listId',
          warpClass: 'mescroll-totop-my',
          src: require('../../assets/image/common/top1.png'), // 图片路径,默认null,支持网络图
          offset: 1000 // 列表滚动1000px才显示回到顶部按钮
        },
        empty: {
          // 列表第一页无任何数据时,显示的空提示布局; 需配置warpId才显示
          // warpId: "main", //父布局的id (1.3.5版本支持传入dom元素)
          // icon: "../../assets/image/common/empty.png", //图标,默认null,支持网络图
          // tip: "暂无相关数据~" //提示
        }
      },
      dataList: [], // 列表数据
      promotion_scene_id: '',
      showtkl: false,
      tkl: ''
    }
  },
  created() {
    // console.log(this.dataList)
    this.getRelationId()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {

    })
  },
  mounted() {
  },
  methods: {
    // 下拉刷新
    downCallback(val) {
      this.$emit('getinfo')
      this.upCallback(val)
    },
    // 上拉加载
    upCallback(val) {
      console.log(val)
      let data = {
        pageNo: val.num,
        pageSize: val.size
      }
      if (val.num === 1) {
        this.dataList = []
      }
      boutiquePddList(data).then(res => {
        if (res.result === '0') {
          if (val.num === 2) {
            this.dataList = []
          }
          res.dataList ? this.dataList = this.dataList.concat(res.dataList) : ''
          this.mescroll.endByPage(res.dataList ? res.dataList.length : 0, res.totalPage)
        } else {
          this.mescroll.endErr()
        }
      }, err => {
        this.mescroll.endErr()
      })
    },
    // 首页天猫、京东、拼多多618活动跳转
    active(obj) {
      if (obj.type == '0') {  //淘宝活动，饿了么活动(跟淘宝活动调用同样接口getHdongUrl)
        let data = {
          uid: localStorage.getItem('uid'),
          promotion_scene_id: obj.actid
        }
        getHdongUrl(data).then(res => {
          if (res.result === '0') {
            if (res.status === '0') {
              if (this.isWx()) {
                let data = {
                  url: res.hDongUrl,
                  text: obj.title
                }
                openTklCreate(data).then(res => {
                  if (res.result === '0') {
                    this.tkl = '【' + data.text + '】' + res.tkl
                    this.showtkl = true
                  }
                })
              } else {
                window.location.href = res.hDongUrl
              }
            } else {
              // 获取淘宝渠道id
              if (this.isWx()) {
                this.$dialog.alert({
                  title: '提示',
                  message: '您是首次使用我惠省钱平台，为保证您的权益，请你点击右上角的“...”,选择“在浏览器中打开”进行下单。',
                  confirmButtonColor: this.m_color
                }).then(() => {
                })
              } else {
                let backurl = window.g.BeforeURL
                window.location.href = window.g.toBind + backurl
              }
            }
          } else {
            this.showToast(res.resultNote)
          }

        })
      } else if (obj.type == '1') {  //京东活动
        let data = {
          uid: localStorage.getItem('uid'),
          materialId: obj.link,
          couponUrl: ''
        }
        doItemCpsUrl(data).then(res => {
          if (res.result === '0') {
            window.location.href = res.data.shortURL
          }
        })
      } else if (obj.type == '2') {  //拼多多活动
        let data = {
          uid: localStorage.getItem('uid'),
          resource_type: obj.actid,
          url: obj.link
        }
        DuoduoRouter(data).then(res => {
          if (res.result === '0') {
            // alert(res.data.resource_url_response.single_url_list.short_url)
            window.location.href = res.data.resource_url_response.single_url_list.short_url
          }
        })
      } else if (obj.type == '3') {  //饿了么活动(跟淘宝活动调用同样接口getHdongUrl)
        let data = {
          uid: localStorage.getItem('uid'),
          promotion_scene_id: obj.actid
        }
        getHdongUrl(data).then(res => {
          if (res.result === '0') {
            if (res.status === '0') {
              window.location.href = res.hDongUrl
            } else {
              // 获取淘宝渠道id
              if (this.isWx()) {
                this.$dialog.alert({
                  title: '提示',
                  message: '您是首次使用我惠省钱平台，为保证您的权益，请你点击右上角的“...”,选择“在浏览器中打开”进行下单。',
                  confirmButtonColor: this.m_color
                }).then(() => {
                })
              } else {
                let backurl = window.g.BeforeURL
                window.location.href = window.g.toBind + backurl
              }
            }
          } else {
            this.showToast(res.resultNote)
          }
        })
      }
    },
    //15个菜单按钮
    menuTo(item) {
      let type = item.type;
      let name = item.name;
      switch (type) {
        case "1"://我惠云店
          this.$router.push({path: "/benefit", query: {title: name}});
          break;
        case "2"://C2F优选
          this.$router.push({path: "/List", query: {type:"c2fyx",title: name}});
          break;
        case "3"://惠康优品
          this.$router.push({path: "/List", query: {type:"hkyp",title: name}});
          break;
        case "4"://惠拼优选
          this.$router.push({path: "/huipinSearch", query: {title: name}});
          break;
        case "5"://C2F留言
          this.$router.push({path: "/advance", query: {title: name}});
          break;
        case "6"://天猫
          this.$router.push({path: "/goOut", query: {type:"6",title: name}});
          break;
        case "7"://淘宝
          this.$router.push({path: "/goOut", query: {type:"7",title: name}});
          break;
        case "8"://京东
          this.$router.push({path: "/goOut", query: {type:"8",title: name}});
          break;
        case "9"://聚划算
          this.$router.push({path: "/goOut", query: {type:"9",title: name}});
          break;
        case "10"://拼多多
          this.$router.push({path: "/goOut", query: {type:"10",title: name}});
          break;
        case "11"://饿了么
          location.replace("https://fc.ele.me/a/MWJhZDM1OTY5ZTg5MTFlYzllYWEwMDE2M2UxM2FkMTE=?scene=b1f54f1e2793440ea3c1576e91ec1c93");
          break;
        case "12"://抖券
          this.$router.push({path: "/dou", query: {title: name}});
          break;
        case "13"://订酒店
          location.replace("https://click.meituan.com/t?t=3&c=2&p=iPH0ab5zJiAL");
          break;
        case "14"://充话费
          location.replace("https://click.meituan.com/t?t=1&c=2&p=aD7-9b5zzFry");
          break;
        case "15"://新手指南
          this.$router.push({path: "/college", query: {title: name}});
          break;
        default:
          break;
      }
    },
    // 路由跳转
    pushTo(obj, title) {
      if (obj.nav) {
        this.$store.commit('saveNavIndex', obj.nav)
      }
      //我惠赚钱
      if (obj.zhuangqian) {
        let userinfo
        userinfo = localStorage.getItem('userinfo') ? JSON.parse(localStorage.getItem('userinfo')) : {}
        let uid
        uid = localStorage.getItem('uid')
        if (!uid) {
          this.$router.push('/regist')
          return
        }
        // 跳转到外网的方法
        location.replace('https://squirrel.kxbwmedia.com/ditch/aatask?union_id=10239&phoneNum=' + userinfo.phoneNum + '&uuid=' + uid)
      }
      if (obj.songzhaopian) {
        // 跳转到外网的方法
        location.replace('https://songzhaopian.com/?channel=flsjmkb')
      }
      if (obj.elmeurl) {
        location.replace("https://fc.ele.me/a/MWJhZDM1OTY5ZTg5MTFlYzllYWEwMDE2M2UxM2FkMTE=?scene=b1f54f1e2793440ea3c1576e91ec1c93");
      }
      if (obj.meituan) {
        location.replace("https://click.meituan.com/t?t=3&c=2&p=iPH0ab5zJiAL");
      }
      if (obj.url) {
        window.location.href = obj.url
        return
      }
      if (obj.goOutType) {
        let data = {
          uid: localStorage.getItem('uid'),
          client: '0'
        }
        if (this.isWx()) {
          data.client = '1'
        }
        getAuthInfo(data).then(res => {
          if (res.result === '0') {
            window.location.href = this.outUrl[obj.goOutType] + res.authinfo
          }
          console.log(res)
        })
      } else {
        this.$store.commit('savegoOut', true)
        obj.route ? this.$router.push({path: obj.route, query: {title: title}}) : this.$router.push({
          path: obj,
          query: {title: title}
        })
      }
    },
    // 授权之后跳回回调链接，链接上会带一个code，用code调接口去绑定帐号
    getRelationId() {
      if (!localStorage.getItem('uid')) {
        return
      }
      if (this.$route.query.code) {
        let data = {
          uid: localStorage.getItem('uid'),
          code: this.$route.query.code
        }
        getRelationId(data).then(res => {
          if (res.result === '0') {
            localStorage.setItem('isBindTb', '1')
            localStorage.setItem('relation_id', res.relationId)
          } else {
            if (res.resultNote == '重复绑定') {
              var wohui_phone = res.wohui_phone
              this.$dialog.alert({
                title: '温馨提示',
                message: '重复绑定，此淘宝账号已经和我惠账号' + wohui_phone + '绑定，请更换其他淘宝账号。',
                confirmButtonColor: this.m_color
              }).then(() => {
              })//end dialog
            }
          }
        })
      }
    }

  }
}
</script>

<style scoped>
#main {
  /*height: calc(100vh - 150px);*/
  /*overflow: auto;*/
}

.mescroll {
  position: fixed;
  top: 146px; /*no*/
  bottom: 50px; /*no*/
  height: auto; /*如设置bottom:50px,则需height:auto才能生效*/
}

.mescroll1 {
  position: fixed;
  top: 95px !important; /*no*/
  bottom: 50px; /*no*/
  height: auto; /*如设置bottom:50px,则需height:auto才能生效*/
}

.goItem {
  padding-top: .2rem;
}

.tips {
  /*padding: .2rem 0;*/
  padding: 2%;
}

.tips .content {
  background: #f0f0f0;
  line-height: .8rem;
  border-radius: .1rem;
}

.tips .content img {
  vertical-align: middle;
}

.tips .notice {
  /*border-left: 1px solid #e0e0e0;*/
  padding-left: 2%;
}

/*商品推荐*/
.recommen {
  /*margin-top: .3rem;*/
  padding-bottom: .3rem;
}

.recommen .tit {
  line-height: 1rem;
}

.recommen > div {
  padding: 0 4%;
}

.good_item {
  width: 4.2rem;
  flex-shrink: 0;
}

.good_box {
  overflow: hidden;
}

.good_box .scroll {
  overflow: auto;
}

/*  秒杀活动*/
.second_box {
  background: rgb(255, 91, 75);
  padding: 2% 2%;
  /*margin-bottom: 3%;*/
}

.activity, .activity_2 {
  margin: 4% 2%;
  font-family: '黑体';
}

.col-1-2 {
  width: 49%;
  background: white;
  border-radius: .15rem;
  padding: 4% 5%;
}

.col-1-2 .imgbox {
  width: 50%;
  padding-top: 50%;
  /*background: red;*/
}

.activity_2 {

}

.activity_2 .col-1-3 {
  width: 32%;
  padding: 2%;
  border-radius: .15rem;
}

.activity_2 .col-1-3 p {
  line-height: 1.5;
}

.activity_2 .imgbox {
  width: 70%;
  padding-top: 70%;
  /*background: red;*/
  margin: 0 auto .2rem;
}

/*  精选*/
.finegood {
  padding-top: 7%;
}

.fine {
  width: 95%;
  margin: 0 auto;
  flex-wrap: wrap;
}

.fine_item {
  width: 50%;
  margin: .2rem 0;
  border-radius: 0.133333rem;
}

.orange {
  color: #F03A17;
}

</style>



// WEBPACK FOOTER //
// src/view/home/fine.vue